export default "__VITE_ASSET__e7b88c1e__"